import StatsSection from "components/Secondary/StatsSection";
import TableTop from "./TableTop";
import FeesTable from "./Table";
import "./style.scss"

const firstTableMock =[
  {
    tier: 1,
    balance: "1,000 PRISM",
    value: "YES",
    discount: "3%"
  },
  {
    tier: 2,
    balance: "1,000 PRISM",
    value: "NO",
    discount: "3%"
  },
  {
    tier: 1,
    balance: "1,000 PRISM",
    value: "YES",
    discount: "3%"
  },
  {
    tier: 2,
    balance: "1,000 PRISM",
    value: "NO",
    discount: "3%"
  },
  {
    tier: 1,
    balance: "1,000 PRISM",
    value: "YES",
    discount: "3%"
  },
  {
    tier: 2,
    balance: "1,000 PRISM",
    value: "NO",
    discount: "3%"
  },
  {
    tier: 1,
    balance: "1,000 PRISM",
    value: "YES",
    discount: "3%"
  },
  {
    tier: 2,
    balance: "1,000 PRISM",
    value: "NO",
    discount: "3%"
  },
  {
    tier: "VIP",
    balance: "1,000 PRISM",
    value: "YES",
    discount: "3%"
  },
]

const Fees = ({}) => {

  return <div className="fees">
    <StatsSection items={[
      {
        label:"Fees",
        value: "$1,605.44",
        description: "All time"
      },
      {
        label:"Maker Fee",
        value: "0.05%",
        description: "All time"
      },
      {
        label:"Taker Fee",
        value: "0.10%",
        description: "All time"
      },
    ]}/>
    <div className="tablesContainer">
      <div className="table">
        <TableTop 
        title={"Fee Discounts"} 
        redirect={"some url"} 
        description={"Hold or stake PRISM tokens to activate fee discounts"}/>
        <FeesTable 
        data={firstTableMock} 
        titles={["Tier", "PRISM Balance", "Staking Required", "Discount"]}
        info={"some text"}/>
      </div>

      <div className="table">
        <TableTop 
        title={"Volume Based Discounts"} 
        description={"Trade to receive fee discounts based on volume"}/>
        <FeesTable 
        data={firstTableMock} 
        titles={["Tier", "Volume (30d)", "Maker Fee", "Taker Fee"]}/>
      </div>
    </div>
  </div>
}

export default Fees;